import { useIntl } from 'react-intl';
import { dataDictToI18nVariablesObject } from '../i18n-text/i18n-text';
import { i18nKeys } from '../i18n-keys';
import defaults from '../i18n-defaults.json';

function capitalizeFirstLetterOfString(str?: string): string {
  if (!str) {
    return '';
  }

  return str?.charAt(0).toUpperCase() + str.slice(1);
}

export type TranslateProps = {
  id?: string | null;
  plural?: boolean;
  capitalizeFirstLetter?: boolean;
  lowercase?: boolean;
  defaultMessage?: string;
  data?: { [key: string]: any };
  renderEmptyIfValueDoesNotExist?: boolean;
};

export type TranslateFunction = (props: TranslateProps) => string;

export const useTranslate = (): TranslateFunction => {
  const intl = useIntl();

  return ({
    id,
    data,
    plural,
    capitalizeFirstLetter,
    lowercase,
    defaultMessage,
    renderEmptyIfValueDoesNotExist,
  }: TranslateProps) => {
    if (!id) {
      return '';
    }
    const normalizedData = dataDictToI18nVariablesObject({ data, plural });

    const textValueFromKeysDictionary = intl.messages[id];

    const message = intl.formatMessage(
      {
        id,
        defaultMessage: defaultMessage || defaults[id as keyof typeof i18nKeys],
      },
      normalizedData,
    );

    // if we dont want to render they key as default fallback
    if (renderEmptyIfValueDoesNotExist && !textValueFromKeysDictionary && !defaultMessage) {
      return '';
    }
    if (capitalizeFirstLetter) {
      return capitalizeFirstLetterOfString(message);
    }
    if (lowercase) {
      return message?.toLowerCase?.();
    }
    return message;
  };
};
